import { render } from "./AcceptationCessionPage.vue?vue&type=template&id=24915fec&ts=true"
import script from "./AcceptationCessionPage.vue?vue&type=script&lang=ts"
export * from "./AcceptationCessionPage.vue?vue&type=script&lang=ts"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__